import { Header } from 'components/Layout/Header/Header';
import { Webline } from 'components/Layout/Webline/Webline';
import useTranslation from 'next-translate/useTranslation';

export const SimpleErrorLayout: FC = ({ children }) => {
    const { t } = useTranslation();

    return (
        <div className="flex min-h-screen flex-col">
            <Webline className="relative flex" type="colored">
                <Header simple />
            </Webline>
            <main
                aria-label={t('Error page content')}
                className="mx-auto flex w-full flex-1 items-center justify-center"
                id="main-content"
            >
                {children}
            </main>
        </div>
    );
};
